import { render, staticRenderFns } from "./drawrule.vue?vue&type=template&id=bc79df12&scoped=true"
import script from "./drawrule.vue?vue&type=script&lang=js"
export * from "./drawrule.vue?vue&type=script&lang=js"
import style0 from "./drawrule.vue?vue&type=style&index=0&id=bc79df12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc79df12",
  null
  
)

export default component.exports